import { pickBy } from 'lodash'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      count: 0,
      page: parseInt(this.$route.query.page, 10) || 1,
      itemsPerPage: parseInt(this.$route.query.itemsPerPage, 10) || 30,
      loading: true,
      pagination: {},
      type: this.$route.params.type,
      search: {},
      searchFieldProps: {
        density: 'compact',
        variant: 'outlined',
        hideDetails: 'auto'
      }
    }
  },
  computed: {
    params () {
      return pickBy({
        limit: this.itemsPerPage,
        offset: (this.page - 1) * this.itemsPerPage,
        type: this.type && this.types[this.type],
        ...this.search
      }, v => v !== undefined)
    },
    // What Vuetify 2 took as footer-props; Vuetify 3 takes the list as a prop
    // of the table itself, and still labels -1 "Kõik".
    itemsPerPageOptions () {
      return [10, 20, 30, -1]
    }
  },
  watch: {
    // What Vue 2 did in a beforeRouteUpdate guard. Vue Router 4 reads route
    // guards off the component's own options only — one in a mixin is never
    // called — so the same work is done here, after the change rather than
    // before it, which nothing below depends on. A list page is re-used when the
    // menu moves between its types (Erakliendid -> Firmad), and the query this
    // mixin writes itself comes back through here as well: that is what
    // refreshes the list.
    //
    // Only where Vue 2 would have called the guard: on a component the router
    // itself rendered for this route. The event list inside an object's
    // Kalender tab mixes this in too, and refreshes off its own params.
    $route (to, from) {
      if (to.name !== from.name) {
        return
      }
      const routed = to.matched.some(record => Object.values(record.instances).includes(this))
      if (!routed) {
        return
      }
      if (this.type && this.type !== to.params.type) {
        this.page = 1
      }
      this.type = to.params.type
      this.refresh()
    },
    params: {
      handler (params) {
        // A copy: `params` is the computed the list is fetched with, and
        // writing page/itemsPerPage into it sent them to the API as filters.
        // replace, not push: every keystroke in a filter used to be its own
        // history entry, and Back stepped through them instead of leaving.
        const query = { ...pickBy(params, (v, k) => !['offset', 'limit'].includes(k)), page: this.page, itemsPerPage: this.itemsPerPage }
        this.$router
          .replace({ query })
          .catch(() => {})
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['showNotification']),
    async refresh () {
      // Numbered: the answer to an earlier keystroke can arrive after the
      // answer to a later one, and must not be the one left on screen.
      const request = this.listRequest = (this.listRequest || 0) + 1
      try {
        this.loading = true
        const response = await this.listViewConf.apiMethod(this.params)
        if (request !== this.listRequest) return
        this[this.listViewConf.itemKey] = response[this.listViewConf.itemKey]
        this.count = response.count
      } catch (err) {
        if (request === this.listRequest) {
          this.showNotification({ text: err.message, color: 'red' })
        }
      } finally {
        if (request === this.listRequest) {
          this.loading = false
        }
      }
    }
  },
  mounted () {
    this.refresh()
  }
}